//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from 'vuelidate/lib/validators';
import ValidationMixin from './mixins/ValidationMixin';

export default {
  name: 'VendorEmailInput',
  mixins: [ValidationMixin],
  props: {
    value: {
      type: String,
    },
    placeholder: {
      default: 'Email Address',
    },
  },
  validations: {
    value: {
      required,
    },
  },
  methods: {
    getErrors() {
      const errors = [];
      if (!this.$v.required) {
        errors.push('Email is required');
      }
      return errors;
    },
  },
};
